import FaresGridBackgroundImage from '../../../../components/containers/FaresGridBackgroundImage';
import preloadCustomProps from '../../../utils/preloads/preloadFaresGridBackgroundImage';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fares-grid-background-image',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FaresGridBackgroundImage
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
